export const data = [
  {
    id: 1,
    category: "Self improvement",
    author: "Nesrine Bedhief",
    Photo:
      "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-9/138088761_1775325139304093_187038969388348350_o.jpg?_nc_cat=108&ccb=2&_nc_sid=09cbfe&_nc_ohc=jUkhj4vwdQQAX_Rj6K4&_nc_ht=scontent-sjc3-1.xx&oh=909f892d820d63803b53bd019e6b5d82&oe=602CB66A",
    date: "20 janvier 2021",
    title: "Improve my career & expand my business",
    image:
      "https://static.wixstatic.com/media/nsplsh_b286ae9105ea4d099c2e39ebf212db10~mv2.jpg/v1/fill/w_357,h_268,fp_0.50_0.50,q_90/nsplsh_b286ae9105ea4d099c2e39ebf212db10~mv2.webp",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Veniam suscipit, consectetur deleniti corrupti est dicta dolore modi explicabo sequi unde.",
    readtime: 2,
    linkUrl: "/Self improvement",
  },
  {
    id: 11,
    category: "Self improvement",
    author: "Nesrine Bedhief",
    Photo:
      "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-9/138088761_1775325139304093_187038969388348350_o.jpg?_nc_cat=108&ccb=2&_nc_sid=09cbfe&_nc_ohc=jUkhj4vwdQQAX_Rj6K4&_nc_ht=scontent-sjc3-1.xx&oh=909f892d820d63803b53bd019e6b5d82&oe=602CB66A",
    date: "20 janvier 2021",
    title: "Improve my career & expand my business",
    image:
      "https://static.wixstatic.com/media/nsplsh_b286ae9105ea4d099c2e39ebf212db10~mv2.jpg/v1/fill/w_357,h_268,fp_0.50_0.50,q_90/nsplsh_b286ae9105ea4d099c2e39ebf212db10~mv2.webp",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Veniam suscipit, consectetur deleniti corrupti est dicta dolore modi explicabo sequi unde.",
    readtime: 2,
    linkUrl: "/Self improvement",
  },
  {
    id: 2,
    category: "Business",
    author: "Nesrine Bedhief",
    Photo:
      "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-9/138088761_1775325139304093_187038969388348350_o.jpg?_nc_cat=108&ccb=2&_nc_sid=09cbfe&_nc_ohc=jUkhj4vwdQQAX_Rj6K4&_nc_ht=scontent-sjc3-1.xx&oh=909f892d820d63803b53bd019e6b5d82&oe=602CB66A",
    date: "20 janvier 2021",
    image:
      "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80",
    title: "When Do You Need a Life Coach?",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Veniam suscipit, consectetur deleniti corrupti est dicta dolore modi explicabo sequi unde.",
    readtime: 2,
    linkUrl: "/Business",
  },
  {
    id: 3,
    category: "Relationship",
    author: "Nesrine Bedhief",
    date: "20 janvier 2021",
    Photo:
      "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-9/138088761_1775325139304093_187038969388348350_o.jpg?_nc_cat=108&ccb=2&_nc_sid=09cbfe&_nc_ohc=jUkhj4vwdQQAX_Rj6K4&_nc_ht=scontent-sjc3-1.xx&oh=909f892d820d63803b53bd019e6b5d82&oe=602CB66A",
    image:
      "https://images.unsplash.com/photo-1468971050039-be99497410af?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=890&q=80",
    title: "When Do You Need a Life Coach?",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Veniam suscipit, consectetur deleniti corrupti est dicta dolore modi explicabo sequi unde.",
    readtime: 4,
    linkUrl: "/Relationship",
  },
  {
    id: 4,
    category: "Business",
    author: "Nesrine Bedhief",
    date: "20 janvier 2021",
    Photo:
      "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-9/138088761_1775325139304093_187038969388348350_o.jpg?_nc_cat=108&ccb=2&_nc_sid=09cbfe&_nc_ohc=jUkhj4vwdQQAX_Rj6K4&_nc_ht=scontent-sjc3-1.xx&oh=909f892d820d63803b53bd019e6b5d82&oe=602CB66A",
    image:
      "https://images.unsplash.com/photo-1497561813398-8fcc7a37b567?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=750&q=80",
    title: "When Do You Need a Life Coach?",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Veniam suscipit, consectetur deleniti corrupti est dicta dolore modi explicabo sequi unde.",
    readtime: 12,
    linkUrl: "/Relationship",
  },
  {
    id: 5,
    category: "Business",
    author: "Nesrine Bedhief",
    date: "20 janvier 2021",
    Photo:
      "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-9/138088761_1775325139304093_187038969388348350_o.jpg?_nc_cat=108&ccb=2&_nc_sid=09cbfe&_nc_ohc=jUkhj4vwdQQAX_Rj6K4&_nc_ht=scontent-sjc3-1.xx&oh=909f892d820d63803b53bd019e6b5d82&oe=602CB66A",
    image:
      "https://images.unsplash.com/photo-1551892589-865f69869476?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80",
    title: "When Do You Need a Life Coach?",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Veniam suscipit, consectetur deleniti corrupti est dicta dolore modi explicabo sequi unde.",
    readtime: 20,
    linkUrl: "/Business",
  },
];
